export const CustomListComponentsMap: any = {
}